import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import WebApp from '@twa-dev/sdk'
import { useBackButton } from '@/shared/hooks/useBackButton'

function OpenEgsGuide({ onBack }: { onBack: () => void }) {
  useBackButton({ onBack })
  function openEgs() {
    WebApp.openLink('https://store.epicgames.com/ru/u')
  }
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.openEgs
  return (
    <div className={classes.root}>
      <h1 className={classes.title}>{text.title}</h1>
      <br />
      <p className={classes.sub}>{text.sub}</p>
      <br />
      <div className={classes.section}>
        <h2>{text.step} 1</h2>
        <p>{text.openEgs(openEgs)}</p>
      </div>
      <br />
      <div className={classes.section}>
        <h2>{text.step} 2</h2>
        <p>{text.myAchievements}</p>
        <img src="/assets/backgrounds/privacy.webp" />
      </div>
      <br />
      <div className={classes.section}>
        <h2>{text.step} 3</h2>
        <p>{text.threeDots}</p>
        <img src="/assets/backgrounds/manageprivacy.webp" />
      </div>
      <br />
      <div className={classes.section}>
        <h2>{text.step} 4</h2>
        <p>{text.openProfile}</p>
        <img src="/assets/backgrounds/manageprivacy2.webp" />
      </div>
    </div>
  )
}

export default OpenEgsGuide
